import { render, staticRenderFns } from "./ImageAlert2.vue?vue&type=template&id=7ff0bef4&scoped=true&"
import script from "./ImageAlert2.vue?vue&type=script&lang=js&"
export * from "./ImageAlert2.vue?vue&type=script&lang=js&"
import style0 from "./ImageAlert2.vue?vue&type=style&index=0&id=7ff0bef4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff0bef4",
  null
  
)

export default component.exports